import React, { Fragment } from 'react';
import { type TComponentsConfig, useComponentsMapContext,ComponentsConfigProvider } from '@monorepo/page-builder';

type Props = {
  componentIds?: string[];
  components: TComponentsConfig;
};

const ComponentsArray: Component<Props> = ({ componentIds = [], components }) => {
  const { componentsMap } = useComponentsMapContext();

  return (
    <>
      {componentIds.map((componentId) => {
        const componentData = components[componentId];
        const type = componentData?.type;

        if (type && componentsMap[type]) {
          const Component: ComponentWithConfig<TConfig> = componentsMap[type];

          return (
            <Fragment key={componentId}>
              <ComponentsConfigProvider params={componentData.config}>
                <Component config={componentData.config || {}} components={components}/>
              </ComponentsConfigProvider>
            </Fragment>
          );
        }
        console.log(`Component type: ${type} id ${componentId} is not defined`, );
        return null;
      })}
    </>
  );
};

export default ComponentsArray;
